import {Component, forwardRef, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SearchFacetGroupCollection} from '../../models/search-facet';

@Component({
    selector: 'app-search-filter',
    templateUrl: './search-filter.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SearchFilterComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SearchFilterComponent implements ControlValueAccessor, OnChanges {
    @Input() facets: SearchFacetGroupCollection[] = [];

    private lastWrittenValue: {[key: string]: string[]} = {};

    private onChange: (value: {[key: string]: string[]}) => void = () => {};
    private onTouched: () => void = () => {};

    form = new FormGroup({});

    overlayOpen = false;

    constructor() {
        this.form.valueChanges.subscribe(value => {
            this.onChange(value);
            this.onTouched();
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        // Remove facets not available in new facets from form
        Object.keys(this.form.controls)
            .filter(key => -1 === this.facets.findIndex(collection => collection.items.find(facet => facet.field === key)))
            .forEach(key => this.form.removeControl(key))

        this.facets.forEach(collection => {
            collection.items.forEach(facet => {
                if (!this.form.contains(facet.field)) {
                    this.form.registerControl(facet.field, new FormControl(
                        this.lastWrittenValue[facet.field] || []
                    ))
                }
            })
        })
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(obj: any): void {
        this.lastWrittenValue = obj;
        this.form.patchValue(obj, {emitEvent: false});
    }

    resetFilters() {
        this.form.patchValue(Object.keys(this.form.controls).reduce((data, key) => {
            data[key] = [];
            return data;
        }, {} as {[key: string]: string[]}));
    }
}
